import './index.css';

export default {
  name: 'Alighting',
  data() {
    return ({
      width: null,
      height: null,
    });
  },
  mounted() {
    this.create();
  },
  methods: {
    create() {
      this.$nextTick(() => {
        !this.width && (this.width = this.$el.clientWidth);
        !this.height && (this.height = this.$el.clientHeight);
      });
    },
  },
  render() {
    const { width, height = '480px', padding, margin } = this.$attrs;
    return (
      <div class="a-lighting" style={{ width, height, padding, margin }}>
        <div
          class="a-lighting-main"
          style={{
            height: `${this.height * 2}px`,
            backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 0, 0.8), rgba(255, 255, 0, 0))`
          }}>
          {this.$slots.default}
        </div>
      </div>
    );
  }
}